import { render, staticRenderFns } from "./robotManage.vue?vue&type=template&id=f982a6aa&scoped=true&"
import script from "./robotManage.vue?vue&type=script&lang=ts&"
export * from "./robotManage.vue?vue&type=script&lang=ts&"
import style0 from "./robotManage.vue?vue&type=style&index=0&id=f982a6aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f982a6aa",
  null
  
)

export default component.exports